import { Directive } from '@angular/core';
@Directive({
  selector: '[fActivityContainer]'
})
export class ActivityContainerDirective {}
